
import { AuthProvider as CoreAuthProvider } from '@/core/auth/AuthProvider';

export { SessionContext } from '@/core/auth/AuthProvider';

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * Application-specific auth provider that uses the generic implementation
 */
export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  return <CoreAuthProvider>{children}</CoreAuthProvider>;
};

export default AuthProvider;
